import { CheckDto } from './check-dto';
import { CustomerVenue } from './Customer/CustomerVenue.entity';
import { CustomerDto } from './DTO/customer-dto';
import { OOMenuItem } from './oo-menu-item';

export class CustomerSubscriptionItem {
	pk: string;
	sk: string;

	menuItemKey: number;
	priceNumber: number;
	quantity: number = 1;

	customerKey: string;

	frequency: number;
	frequencyDisplayName: string;

	token: string;

	nextBillDate: number; //unix of next bill date
	lastBillDate: string;

	totalBilled: number;

	addDate: string;
	lastModified: string;
	inactive: boolean;
	deleted: boolean;
	deleteDate: string;

	orderCheckKeys: string[];
	orders: CheckDto[];
	delivery: boolean;
	deliveryAddressKey: string;

	customerVenue: CustomerVenue;
	customerDto: CustomerDto;

	ooMenuItem: OOMenuItem;

	nextBillDateDate: Date;

	lastBillDateDate: Date;

	price: number;
	venueName: string;

	public constructor(init?: Partial<CustomerSubscriptionItem>) {
		Object.assign(this, init);
	}
}
